/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetContentPageWriteProtectionRequest
 */
export interface SetContentPageWriteProtectionRequest {
    /**
     * 
     * @type {boolean}
     * @memberof SetContentPageWriteProtectionRequest
     */
    writeProtection?: boolean;
}

/**
 * Check if a given object implements the SetContentPageWriteProtectionRequest interface.
 */
export function instanceOfSetContentPageWriteProtectionRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SetContentPageWriteProtectionRequestFromJSON(json: any): SetContentPageWriteProtectionRequest {
    return SetContentPageWriteProtectionRequestFromJSONTyped(json, false);
}

export function SetContentPageWriteProtectionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetContentPageWriteProtectionRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'writeProtection': !exists(json, 'writeProtection') ? undefined : json['writeProtection'],
    };
}

export function SetContentPageWriteProtectionRequestToJSON(value?: SetContentPageWriteProtectionRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'writeProtection': value.writeProtection,
    };
}

